import { render } from "./TeamAdminCupView.vue?vue&type=template&id=b18b8526"
import script from "./TeamAdminCupView.vue?vue&type=script&lang=js"
export * from "./TeamAdminCupView.vue?vue&type=script&lang=js"

import "./TeamAdminCupView.vue?vue&type=style&index=0&id=b18b8526&lang=css"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__